import api from './api';
import { API_ENDPOINTS } from '@/utils/constants';
import type {
  AuthUser,
  LoginRequest,
  LoginResponse,
  SignupRequest,
  SignupResponse,
} from '@/types/auth';

export const authService = {
  /**
   * 로그인. 응답의 `user` 가 화면 분기의 정본이다(계약 §2).
   * 승인 대기·정지 계정은 401 이 아니라 **403 + 사유 문구**로 온다 —
   * api.ts 인터셉터가 401 만 강제 이동시키므로 로그인 화면이 사유를 그릴 수 있다.
   */
  login: async (credentials: LoginRequest): Promise<LoginResponse> => {
    const response = await api.post<LoginResponse>(API_ENDPOINTS.AUTH.LOGIN, credentials);
    return response.data;
  },

  /** 기관 담당자 회원가입. 토큰을 주지 않는다 — 승인 전에는 로그인되지 않는다 */
  signup: async (payload: SignupRequest): Promise<SignupResponse> => {
    const response = await api.post<SignupResponse>(API_ENDPOINTS.AUTH.SIGNUP, payload);
    return response.data;
  },

  /**
   * 로그인한 계정의 비밀번호 재확인 (개인정보 가림 해제).
   * 틀리면 401 이 아니라 400 이 온다 — 인터셉터가 로그아웃시키지 않도록 백엔드가 그렇게 준다.
   */
  verifyPassword: async (
    password: string,
  ): Promise<{ revealToken: string; expiresIn: number }> => {
    const response = await api.post<{ revealToken: string; expiresIn: number }>(
      API_ENDPOINTS.AUTH.VERIFY_PASSWORD,
      { password },
    );
    return response.data;
  },

  /** 이 토큰의 세션을 닫는다. 실패해도 화면은 로그아웃한다 (토큰은 어차피 지운다) */
  logout: async (): Promise<void> => {
    await api.post(API_ENDPOINTS.AUTH.LOGOUT);
  },

  /** 새로고침 후 프로필 복원용. 저장소에는 토큰만 남아 있을 수 있다 */
  me: async (): Promise<AuthUser> => {
    const response = await api.get<AuthUser>(API_ENDPOINTS.AUTH.ME);
    return response.data;
  },
};
